export const setDateFormat = (dateValue: string | Date): string => {
  const utcString = new Date(dateValue)
  const formattedDate = new Date(utcString).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  })

  return formattedDate
}

export const setTimeFormat = (aDateString: string | Date): string => {
  const aDate = new Date(aDateString)
  let hours = aDate.getHours()
  const minutes = aDate.getMinutes().toString().padStart(2, '0')
  const newFormat = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12
  return `${hours}:${minutes} ${newFormat}`
}

export const formatDate = (eventDate: string | Date): string => {
  const newEventDate = new Date(eventDate)
  const year = newEventDate.getFullYear()
  const month = addZero(newEventDate.getMonth() + 1)
  const date = addZero(newEventDate.getDate())
  const hour = addZero(newEventDate.getHours())
  const minute = addZero(newEventDate.getMinutes())
  return `${year}-${month}-${date} ${hour}:${minute}`
}

export const addZero = (number: number): string => {
  return number < 10 ? '0' + number.toString() : number.toString()
}

export const formatDateToUTC = (formattedDate: string | Date): string => {
  const date = new Date(formattedDate)
  const utcDate = new Date(date.getTime() - 8 * 60 * 60 * 1000)
  return utcDate.toISOString()
}

export const formatDateToManilaUTC = (dateInput: string | Date): string => {
  const date = new Date(dateInput)
  const manilaDate = new Date(date.getTime() + 8 * 60 * 60 * 1000)
  return manilaDate.toISOString()
}
